import { CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { FileUpload, FilterAlt } from "@mui/icons-material";
import { deleteData, fetchData } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";
import InsurerRtoFilterDialog from './components/InsurerRtoFilterDialog.js';

const RtoList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    const currentPage = useSelector(
        (state) => state?.rtoStore?.currentPage
    );
    const rowsPerPage = useSelector(
        (state) => state?.rtoStore?.rowsPerPage
    );
    const totalPages = useSelector(
        (state) => state?.rtoStore?.totalPages
    );
    const [isRefresh, setIsRefresh] = useState(false);
    const [rtoData, setRtoData] = useState([]);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        iCityId: "",
        iRtoRegionId: "",
        iRtoZoneId: "",
    });

    useEffect(() => {
        fetchRtoList();
    }, [isRefresh, currentPage, rowsPerPage, search]);

    //List API
    const fetchRtoList = async () => {
        setCircleLoading(true);
        const apiUrl = `/reference/insurer/insurer-rto-master?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
        try {
            const response = await fetchData(apiUrl);

            if (response?.success) {
                setRtoData(response?.data?.items);
                dispatch(setTotalPages(response?.data?.totalPages));
            }
        } catch (error) {
            showSnackbar(error?.response?.data?.message, "error");
        } finally {
            setCircleLoading(false);
        }
    };

    const handleDelete = async (row) => {
        setCircleLoading(true);
        try {
            const response = await deleteData(`/reference/insurer/rto/delete`, {
                ids: [row?.id],
            });
            const responseMessage = response?.message;
            setIsRefresh(!isRefresh);
            if (response?.success) {
                showSnackbar(responseMessage, "success");
            } else {
                showSnackbar(responseMessage, "error");
            }
        } catch (error) {
            showSnackbar(error?.response?.data?.message, "error");
        } finally {
            setCircleLoading(false);
        }
    };

    //Table Mapping
    const rtoListTable = {
        columns: [
            {
                key: "sno",
                label: "S.No.",
                renderCell: (row) => row.sno,
            },
            {
                key: "rtoName",
                label: "RTO Name",
                renderCell: (row) => row.rtoName,
            },
            {
                key: "rtoCode",
                label: "RTO Code",
                renderCell: (row) => row.rtoCode,
            },
            {
                key: "iCityName",
                label: "Insurer City",
                renderCell: (row) => row.iCityName,
            },
            {
                key: "iRtoRegionName",
                label: "Insurer RTO Region",
                renderCell: (row) => row.iRtoRegionName,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                        {row.isActive ? (
                            <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                        ) : (
                            <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                        )}
                    </span>
                ),
            },
        ],
        rows: rtoData?.map((rto, index) => ({
            id: rto?.id,
            sno: index + 1,
            rtoName: rto?.rtoName || "",
            rtoCode: rto?.rtoCode || "",
            code: rto?.code || "",
            isActive: rto?.isActive,
            iCityName: rto?.iCityName || '',
            iRtoRegionName: rto?.iRtoRegionName || '',
            createdAt: new Date(rto?.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            }),
        })),
    };

    const handleAddNewRto = () => {
        navigate(`/insurer-master/insurer-rto/add-rto`);
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(
                `/insurer-master/insurer-rto/add-rto?pageType=edit&id=${row.id}`
            );
        },
        onView: (row) => {
            navigate(
                `/insurer-master/insurer-rto/add-rto?pageType=view&id=${row.id}`
            );
        },
        onDelete: (row) => handleDelete(row),
    };

    const handleSearch = (value) => {
        setSearch(value);
    };
    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    return (
        <DashboardLayout>
            <CardHeader
                title={
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                RTO List
                            </MaterialTypography>
                            <MaterialTypography variant="caption" color="text">
                                List of RTO around the world.
                            </MaterialTypography>
                        </Stack>
                        <Stack direction="row" spacing={1}>
                            <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<FilterAlt/>}
                            onClick={(event) => setAnchorEl(event.currentTarget)}
                            >
                            Filter
                            </MaterialButton>
                            <MaterialButton
                                variant="gradient"
                                color="dark"
                                size="small"
                                startIcon={<FileUpload />}
                            >
                                Bulk Upload
                            </MaterialButton>
                            <MaterialButton
                                variant="gradient"
                                color="dark"
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={() => handleAddNewRto()}
                            >
                                RTO
                            </MaterialButton>
                        </Stack>
                    </Stack>
                }
            />
            <CardContent>
                <Table
                    columns={rtoListTable?.columns}
                    data={rtoListTable?.rows}
                    actions={actions}
                    pagination={{
                        totalPages,
                        currentPage,
                        onPageChange: (page) => handlePaginationChange(page),
                        rowsPerPage,
                        onRowsPerPageChange: (rowsPerPage) =>
                            handleRowsPerPageChange(rowsPerPage),
                        rowsPerPageOptions: [5, 10, 15, 20],
                    }}
                    getRowKey={(row) => row.id}
                    className="custom-table"
                    noDataLabel="No RTO found"
                    handleSearch={handleSearch}
                />
            </CardContent>
            <InsurerRtoFilterDialog
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            filterData={filterData}
            setFilterData={setFilterData}
            onApply={() => {
                setAnchorEl(null);   // close popup
                fetchRtoList();  // call API after filter applied
            }}
            />
        </DashboardLayout>
    );
};

export default RtoList;